module.exports = __webpack_public_path__ + "img/logo-6.1686d172.svg";